module.exports = __webpack_public_path__ + "img/banner-2m.2c983eb9.jpg";